import React, { useMemo } from "react";
import objectPath from "object-path";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { QuickUserToggler } from "../extras/QuiclUserToggler";
import { useFeatureAccessContext } from "../../../../app/contexts/FeaturesAccess";
import { toAbsoluteRouterUrl } from "../../../_helpers";

export function Topbar() {
  const uiService = useHtmlClassService();
  const { menu } = useFeatureAccessContext();

  const layoutProps = useMemo(() => {
    return {
      viewSearchDisplay: objectPath.get(
        uiService.config,
        "extras.search.display"
      ),
      viewNotificationsDisplay: objectPath.get(
        uiService.config,
        "extras.notifications.display"
      ),
      viewQuickActionsDisplay: objectPath.get(
        uiService.config,
        "extras.quick-actions.display"
      ),
      viewCartDisplay: objectPath.get(uiService.config, "extras.cart.display"),
      viewQuickPanelDisplay: objectPath.get(
        uiService.config,
        "extras.quick-panel.display"
      ),
      viewLanguagesDisplay: objectPath.get(
        uiService.config,
        "extras.languages.display"
      ),
      viewUserDisplay: objectPath.get(uiService.config, "extras.user.display"),
    };
  }, [uiService]);

  const showDevButton = useMemo(() => {
    if (!menu) return false;
    const normalize = (text) =>
      String(text || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
    const target = normalize("Programación");
    const matchCaption = (caption) => normalize(caption) === target;

    const hasInFeatures = (features = []) => {
      return features.some((feature) => {
        if (!feature) return false;
        if (matchCaption(feature.caption)) return true;
        if (Array.isArray(feature.features) && hasInFeatures(feature.features)) return true;
        return false;
      });
    };

    if (menu.sectionRoot) {
      if (matchCaption(menu.sectionRoot.caption)) return true;
      if (hasInFeatures(menu.sectionRoot.features)) return true;
    }
    if (Array.isArray(menu.sections)) {
      return menu.sections.some((section) => {
        if (!section) return false;
        if (matchCaption(section.caption)) return true;
        return hasInFeatures(section.features);
      });
    }
    return false;
  }, [menu]);

  return (
    <div className="topbar">
      {/*layoutProps.viewSearchDisplay && <SearchDropdown />*/}

      {/*layoutProps.viewNotificationsDisplay && <UserNotificationsDropdown />*/}

      {/*layoutProps.viewQuickActionsDisplay && <QuickActionsDropdown />*/}

      {/*layoutProps.viewCartDisplay && <MyCartDropdown />*/}

      {/*layoutProps.viewQuickPanelDisplay && (
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id="quick-panel-tooltip">Quick panel</Tooltip>}
        >
          <div
            className="topbar-item"
            data-toggle="tooltip"
            title="Quick panel"
            data-placement="right"
          >
            <div
              className="btn btn-icon btn-clean btn-lg mr-1"
              id="kt_quick_panel_toggle"
            >
              <span className="svg-icon svg-icon-xl svg-icon-primary">
                <SVG
                  src={toAbsoluteUrl(
                    "/media/svg/icons/Layout/Layout-4-blocks.svg"
                  )}
                />
              </span>
            </div>
          </div>
        </OverlayTrigger>
                  )*/}

      {/*layoutProps.viewLanguagesDisplay && <LanguageSelectorDropdown />*/}

      {showDevButton && (
        <div className="topbar-item">
          <a
            className="btn btn-light-primary btn-sm font-weight-bolder mr-2"
            href={toAbsoluteRouterUrl("dev")}
          >
            Modo desarrollo
          </a>
        </div>
      )}

      {layoutProps.viewUserDisplay && <QuickUserToggler />}
    </div>
  );
}
